import React, { Fragment } from "react";

import img13 from "../../../images/service/dapps/dapps-banner1.png";
import img14 from "../../../images/service/dapps/dapps-banner2.png";
import img15 from "../../../images/service/dapps/dapps-banner3.png";

// Service icons
import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";
import sIcon5 from "../../../images/icon/service-icon05.svg";
import sIcon6 from "../../../images/icon/service-icon06.svg";

// Common Components
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

import HeroSection from "../../../components/PageSection/HeroSection";
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import Benefit from "../../../components/PageSection/BenefitSection";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";
import Industries from "../../../components/Industries/Industries";
import TheorySection from "../../../components/PageSection/Theory";

// =====================
// DATA
// =====================

const serviceCards = [
  {
    icon: sIcon1,
    title: "Custom dApp Development",
    content:
      "We build scalable, secure decentralized applications tailored to your business use cases.",
  },
  {
    icon: sIcon2,
    title: "Smart Contract Integration",
    content:
      "Seamless integration of audited smart contracts for automated and trustless operations.",
  },
  {
    icon: sIcon3,
    title: "UI/UX for Web3 Applications",
    content:
      "User-friendly interfaces that simplify blockchain interactions for end users.",
  },
];

const benefits = [
  {
    title: "Decentralization",
    description:
      "Eliminate central authority and ensure user ownership of data and assets.",
    icon: sIcon1,
  },
  {
    title: "High Security",
    description:
      "Blockchain-backed architecture protects applications from data tampering.",
    icon: sIcon2,
  },
  {
    title: "Transparency",
    description:
      "All transactions and logic are verifiable on the blockchain.",
    icon: sIcon3,
  },
  {
    title: "Scalability",
    description:
      "Designed to scale with growing user adoption and transaction volume.",
    icon: sIcon4,
  },
];

const faqs = [
  {
    q: "What is a dApp?",
    a: "A decentralized application (dApp) runs on a blockchain network and operates without a central authority.",
  },
  {
    q: "Which blockchains are best for dApp development?",
    a: "Ethereum, Binance Smart Chain, Polygon, Solana, Avalanche, and Cardano are popular choices.",
  },
  {
    q: "Are dApps secure?",
    a: "Yes. When built with audited smart contracts and secure architecture, dApps offer high security.",
  },
  {
    q: "Can dApps scale to millions of users?",
    a: "Yes. Using Layer 2 solutions and scalable infrastructure, dApps can handle large user bases.",
  },
];

// =====================
// PAGE COMPONENT
// =====================

export default function DAppDevelopment() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="dApp Development"
        pagesub="Scalable, secure & decentralized applications"
      />

      {/* HERO SECTION */}
      <HeroSection
        title={
          <>
            Build Powerful{" "}
            <span className="gradient-text">Decentralized Applications</span>
          </>
        }
        subtitle={`Leverage blockchain technology to build transparent,
secure, and user-centric decentralized applications.`}
        buttonText="Book Consultation"
        buttonLink="/contact"
        image={img13}
        imageAlt="dApp Development"
      />

      {/* ================= THEORY 1 ================= */}
      <TheorySection
        title="What Is dApp Development?"
        image={img14}
        paragraphs={[
          "Decentralized applications (dApps) are software applications that run on blockchain networks rather than centralized servers.",
          "They use smart contracts for backend logic and enable trustless, transparent interactions between users.",
        ]}
      />

      {/* SERVICES */}
      <ServiceCardsSection
        title="Our dApp Development Services"
        cards={serviceCards}
      />

      {/* ================= THEORY 2 ================= */}
      <TheorySection
        title="Why Choose dApps Over Traditional Apps?"
        image={img15}
        paragraphs={[
          "Traditional applications rely on centralized infrastructure, which can lead to data breaches, downtime, and lack of transparency.",
          "dApps remove these limitations by distributing control, enhancing security, and empowering users with ownership.",
        ]}
      />

      {/* BENEFITS */}
      <Benefit
        title="Benefits of dApp Development"
        benefits={benefits}
      />

      {/* KEY FEATURES */}
      <KeyFeaturesSection
        title="Key Features of Our dApp Solutions"
        subtitle="Designed for performance, security, and usability"
        features={[
          {
            icon: sIcon1,
            title: "Decentralized Backend",
            description:
              "Smart contracts replace centralized servers.",
          },
          {
            icon: sIcon2,
            title: "Wallet Integration",
            description:
              "Support for MetaMask, WalletConnect, and more.",
          },
          {
            icon: sIcon3,
            title: "Cross-Chain Support",
            description:
              "Deploy on multiple blockchain networks.",
          },
          {
            icon: sIcon4,
            title: "Scalable Architecture",
            description:
              "Layer 2 and sidechain compatibility.",
          },
          {
            icon: sIcon5,
            title: "Secure Transactions",
            description:
              "Cryptographically secured user interactions.",
          },
          {
            icon: sIcon6,
            title: "Continuous Support",
            description:
              "Monitoring, upgrades, and performance optimization.",
          },
        ]}
      />

      <Industries />

      {/* WHY CHOOSE US */}
      <WhyChooseUsSection
        items={[
          "Experienced Web3 developers",
          "End-to-end dApp development lifecycle",
          "Security-first development approach",
        ]}
      />

      {/* FAQ */}
      <FaqSection faqs={faqs} />

      {/* FINAL CTA */}
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
